export const CLIENT_REQUEST_REQUEST_REQUEST = 'CLIENT_REQUEST_REQUEST_REQUEST'
export const CLIENT_REQUEST_REQUEST_SUCCESS = 'CLIENT_REQUEST_REQUEST_SUCCESS'
export const CLIENT_REQUEST_REQUEST_ERROR = 'CLIENT_REQUEST_REQUEST_ERROR'

export const CLIENT_REQUEST_ONE_REQUEST = 'CLIENT_REQUEST_ONE_REQUEST'
export const CLIENT_REQUEST_ONE_SUCCESS = 'CLIENT_REQUEST_ONE_SUCCESS'
export const CLIENT_REQUEST_ONE_ERROR = 'CLIENT_REQUEST_ONE_ERROR'